import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcEmpty',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'noData',
    },
  },
  data() {
    return {};
  },
  watch: {},
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  created() {},
  mounted() {},
  methods: {
    renderText(prefixCls, title, description) {
      return (
        <div class={`${prefixCls}-textArea `}>
          {title && <span class={`${prefixCls}-title `}>{title}</span>}

          {description && <span class={`${prefixCls}-description `}>{description}</span>}
        </div>
      );
    },
  },
  render(h) {
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-empty');
    const prefixClsRoot = getPrefixCls('', 'fc');
    const { _props } = this;
    const { type, title, description, style } = _props;
    return (
      <div class={prefixCls} style={style}>
        {type === 'noPermission' && (
          <div class={`${prefixCls}-imgWrap `}>
            <div class={`${prefixClsRoot}-noPermission`} />
            {this.renderText(prefixCls, title, description)}
          </div>
        )}

        {type === 'noMessage' && (
          <div class={`${prefixCls}-imgWrap `}>
            <div class={`${prefixClsRoot}-noMessage`} />
            {this.renderText(prefixCls, title, description)}
          </div>
        )}

        {type === 'noData' && (
          <div class={`${prefixCls}-imgWrap `}>
            <div class={`${prefixClsRoot}-noData`} />
            {this.renderText(prefixCls, title, description)}
          </div>
        )}

        {type === 'noService' && (
          <div class={`${prefixCls}-imgWrap `}>
            <div class={`${prefixClsRoot}-noService`} />
            {this.renderText(prefixCls, title, description)}
          </div>
        )}
      </div>
    );
  },
};
